import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    MenuItem,
    Pagination,
    Slide,
    TextField,
    useMediaQuery,
    useTheme
} from "@mui/material";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import {TransitionProps} from "@mui/material/transitions";
import {AxiosRequestConfig} from "axios";
import Loader from "components/loader";
import {useAppSelector} from "store";
import {useConfigState} from "store/config";
import React, {useCallback, useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {OrcamentosService} from "services/OrcamentosService";
import {CondicaoOrcamento} from "types/orcamento";
import {RestPage} from "types/prtoheuspage";
import {PAGE_SIZE_SELECT} from "utils/constants";
import {grey} from "@mui/material/colors";
import OrcamentoModalCondicoesRow from "components/orcamento/modals/condicoes/row";

type Props = {
    show: boolean;
    setShow: (show: boolean) => void;
    handleSelect: (data: CondicaoOrcamento) => void;
    codigoCliente: string;
};

type SearchProps = {
    nome: string;
    codigoPag: string;
};

const SendButton = styled(Button)({
    width: "100%",
    height: "100%",
});

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalCondicao = ({show, setShow, handleSelect, codigoCliente = "",}: Props) => {
    const {
        handleSubmit,
        register,
        reset,
        formState: {errors},
    } = useForm<SearchProps>({defaultValues: {nome: "", codigoPag: ""}});
    const [page, setPage] = useState<RestPage<CondicaoOrcamento>>();
    const config = useAppSelector(useConfigState);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [nome, setNome] = useState("");
    const [codigoPag, setCodigoPag] = useState("");
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const xs = useMediaQuery(theme.breakpoints.down("md"));

    const handleAction = (originalRow: CondicaoOrcamento) => {
        handleSelect(originalRow);
        setPageCount(0);
        reset();
    };


    const getCondicoes = useCallback(() => {
        setIsLoading(true);
        const params: AxiosRequestConfig = {
            params: {
                nome: nome,
                codigoPag: codigoPag,
                page: pageCount,
                size: pageSize,
                codigoCliente,
            },
        };
        OrcamentosService.findCondicoes(config.empresa.empresaCodigo, params)
            .then((res) => {
                setPage(res.data);
            })
            .catch((err) => {
                toast.error(
                    err.response.data.message ||
                    "Erro ao carregar os condicoes de pagamento"
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [codigoPag, nome, pageCount, config.empresa.empresaCodigo, pageSize, codigoCliente]);

    useEffect(() => {
        getCondicoes();
    }, [getCondicoes]);

    const onSubmit = (data: SearchProps) => {
        setNome(data.nome);
        setCodigoPag(data.codigoPag);
        setPageCount(0);
    };

    const handleChangePageSize = (e: any) => {
        setPageCount(0);
        setPageSize(e.target.value);
    }

    return (
        <div>
            <Dialog
                open={show}
                TransitionComponent={Transition}
                fullWidth={true}
                maxWidth={"xl"}
                fullScreen={fullScreen}
                keepMounted
                onClose={() => setShow(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogTitle>{"Condições de pagamento"}</DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit(onSubmit)}
                        sx={{mt: 1}}
                    >
                        <Grid container spacing={2}>
                            <Grid item md={5} xs={12}>
                                <TextField
                                    {...register('nome')}
                                    error={!!errors.nome}
                                    type={"text"}
                                    label="Nome"
                                    variant="outlined"
                                    sx={{width: "100%"}}
                                    helperText={errors.nome?.message}
                                />
                            </Grid>
                            <Grid item md={5} xs={12}>
                                <TextField
                                    {...register('codigoPag')}
                                    error={!!errors.codigoPag}
                                    type={"text"}
                                    label="Codigo condição"
                                    variant="outlined"
                                    sx={{width: "100%"}}
                                    helperText={errors.codigoPag?.message}
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <SendButton type={"submit"} variant="contained" size="large">
                                    Buscar
                                </SendButton>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{display: "flex", width: "100%", mt: 3}}>
                        {isLoading && <Loader/>}
                        {!isLoading && page &&
                            <Grid container>
                                {!xs &&
                                <Grid item container sx={{
                                    border: 1,
                                    borderColor: grey[300],
                                    backgroundColor: grey[100],
                                    p: 1,
                                    fontWeight: 800
                                }}>
                                    <Grid item md sx={{textAlign: "center"}}>Ações</Grid>
                                    <Grid item md sx={{textAlign: "center"}}>Código</Grid>
                                    <Grid item md sx={{textAlign: "center"}}>Descrição</Grid>
                                    <Grid item md sx={{textAlign: "center"}}>Forma</Grid>
                                </Grid>}
                                {page.conteudo.map((row, index) => (
                                   <OrcamentoModalCondicoesRow row={row} handleAction={handleAction} key={index} />
                                ))}
                                <Grid container item xs={12} sx={{pt: 2, display: "flex", alignItems: "center"}}>
                                    <Grid item xs={6} md={6} sx={{textAlign: "left"}}>
                                        <Pagination
                                            count={Math.ceil(parseInt(page?.quantidade) / pageSize)}
                                            defaultPage={1}
                                            page={pageCount + 1}
                                            onChange={(event, value) => {
                                                setPageCount(value - 1);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={6} sx={{textAlign: "right"}}>
                                        <TextField
                                            id="outlined-select-currency"
                                            select
                                            label="Registros por pagina"
                                            onChange={handleChangePageSize}
                                            size="small"
                                            value={pageSize}
                                            sx={{minWidth: 150}}
                                        >
                                            {PAGE_SIZE_SELECT.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>

                            </Grid>
                        }
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ModalCondicao;
